import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { SectionHeading } from "./Reveal";
import { useLanguage } from "@/context/LanguageContext";

const CoreValues = () => {
  const { t } = useLanguage();

  const valuesList = [
    { icon: "ShieldCheck", title: t("values.v1Title"), desc: t("values.v1Desc") },
    { icon: "Sparkles", title: t("values.v2Title"), desc: t("values.v2Desc") },
    { icon: "Handshake", title: t("values.v3Title"), desc: t("values.v3Desc") },
    { icon: "Smile", title: t("values.v4Title"), desc: t("values.v4Desc") },
    { icon: "TrendingUp", title: t("values.v5Title"), desc: t("values.v5Desc") },
    { icon: "Lightbulb", title: t("values.v6Title"), desc: t("values.v6Desc") },
  ];

  return (
    <section id="values" className="relative py-24 md:py-36 bg-white" data-testid="values-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading
          eyebrow={t("values.eyebrow")}
          title={`${t("values.title")} ${t("values.titleHighlight")}`}
          subtitle=""
          testid="values"
          align="center"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
          {valuesList.map((v, i) => {
            const Icon = Icons[v.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
                className="group flex items-start gap-5 rounded-3xl border border-[#95d5b2]/40 bg-[#f8fff8] p-8 hover:bg-white hover:shadow-xl hover:shadow-[#2d6a4f]/8 transition-all"
                data-testid={`value-card-${i}`}
              >
                <div className="h-12 w-12 rounded-xl bg-[#d8f3dc] flex items-center justify-center text-[#2d6a4f] group-hover:bg-[#40916c] group-hover:text-white transition-colors shrink-0">
                  <Icon size={22} strokeWidth={1.8} />
                </div>
                <div>
                  <h3 className="font-display text-lg font-semibold text-[#222222]">{v.title}</h3>
                  <p className="font-body text-sm text-[#5b6b62] mt-1.5 leading-relaxed">{v.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CoreValues;
